import { createContext } from 'react'

import { getAppConfig } from '.'

const appConfigContext = createContext(getAppConfig())

export default appConfigContext
